import { render, staticRenderFns } from "./StandardLayoutNav.vue?vue&type=template&id=4761ab90&scoped=true&"
import script from "./StandardLayoutNav.vue?vue&type=script&lang=ts&"
export * from "./StandardLayoutNav.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayoutNav.vue?vue&type=style&index=0&id=4761ab90&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4761ab90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
